var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgGdpr = function SvgGdpr(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-label": "Security badge",
    viewBox: "0 0 512 512",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 238,
    fill: "#e9edf3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 226,
    fill: "none",
    stroke: "#9aa3af",
    strokeWidth: 24,
    opacity: 0.55
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 226,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 18,
    opacity: 0.55
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 226,
    fill: "none",
    stroke: "#6b7280",
    strokeWidth: 10,
    opacity: 0.35
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 206,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 192,
    fill: "#1237a8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 210,
    r: 140,
    fill: "#fff",
    opacity: 0.08
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 192,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 8,
    opacity: 0.45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fc3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 88 4.4 11H272l-9.4 7 3.6 11.2-10.2-6.4-10.2 6.4 3.6-11.2-9.4-7h11.6ZM340 110.508l-1.69 11.726 10.046 5.8-11.64 1.362-2.483 11.5-5.633-10.643-12.033.443 8.717-7.9-4.64-10.762 10.045 5.8ZM401.492 172l-7.326 9.31 5.8 10.046-10.762-4.64-7.9 8.717.443-12.033-10.643-5.633 11.5-2.483 1.362-11.64 5.8 10.045ZM424 256l-11 4.4V272l-7-9.4-11.2 3.6 6.4-10.2-6.4-10.2 11.2 3.6 7-9.4v11.6ZM401.492 340l-11.726-1.69-5.8 10.046-1.362-11.64-11.5-2.483 10.643-5.633-.443-12.033 7.9 8.717 10.762-4.64-5.8 10.045ZM340 401.492l-9.31-7.326-10.046 5.8 4.64-10.762-8.717-7.9 12.033.443 5.633-10.643 2.483 11.5 11.64 1.362-10.045 5.8ZM256 424l-4.4-11H240l9.4-7-3.6-11.2 10.2 6.4 10.2-6.4-3.6 11.2 9.4 7h-11.6ZM172 401.492l1.69-11.726-10.046-5.8 11.64-1.362 2.483-11.5 5.633 10.643 12.033-.443-8.717 7.9 4.64 10.762-10.045-5.8ZM110.508 340l7.326-9.31-5.8-10.046 10.762 4.64 7.9-8.717-.443 12.033 10.643 5.633-11.5 2.483-1.362 11.64-5.8-10.045ZM88 256l11-4.4V240l7 9.4 11.2-3.6-6.4 10.2 6.4 10.2-11.2-3.6-7 9.4v-11.6ZM110.508 172l11.726 1.69 5.8-10.046 1.362 11.64 11.5 2.483-10.643 5.633.443 12.033-7.9-8.717-10.762 4.64 5.8-10.045ZM172 110.508l9.31 7.326 10.046-5.8-4.64 10.762 8.717 7.9-12.033-.443-5.633 10.643-2.483-11.5-11.64-1.362 10.045-5.8Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 256)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f4c300",
    strokeLinecap: "round",
    strokeWidth: 20,
    d: "M-44-20v-14c0-30 20-52 44-52s44 22 44 52v14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 116,
    x: -70,
    y: -20,
    fill: "#f4c300",
    rx: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 26,
    r: 18,
    fill: "#0b1f7a",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 46,
    x: -7,
    y: 40,
    fill: "#0b1f7a",
    opacity: 0.95,
    rx: 7
  }))));
};
export default SvgGdpr;